import { analytics } from 'core/analytics/analyticsClient';
import { useCallback, useEffect, useState } from 'react';

const QUEUED = Object.freeze({ queued: true });

/**
 * Fachada del Tutor sobre la analítica in-house (CAM-16). `trackEvent` resuelve `null` sin usuario
 * identificado: los cerrojos de reintento del Tutor lo usan para volver a lanzar el evento.
 */
function useAnalytics() {
  const [isInitialized, setIsInitialized] = useState(() => analytics.isReady());

  useEffect(() => {
    // identify corre en el efecto de InitsContainer y puede llegar entre el render y esta suscripción.
    setIsInitialized(analytics.isReady());
    return analytics.subscribe(setIsInitialized);
  }, []);

  // Cambia al hidratarse a propósito: los efectos del Tutor que dependen de trackEvent se relanzan.
  const trackEvent = useCallback((eventType, payload = {}) => Promise.resolve(analytics.track(eventType, payload) ? QUEUED : null), [isInitialized]);

  return { trackEvent, isInitialized };
}

export default useAnalytics;
